export enum MemberType {
  Member =1,
  
  Stakeholder =2
}
